import { cx, PassProps } from './hooks';

export interface LogoProps extends PassProps {
  /** Mark size in px. Wordmark scales with it. */
  size?: number;
  /** 'dark' = wordmark in white (for plum hero surfaces); 'light' = plum wordmark. */
  tone?: 'light' | 'dark';
  /** Mark only (app icon style). */
  markOnly?: boolean;
  className?: string;
}

/** Rounded coral square with a plum 'P' stroke. Colours are tokens so it follows the theme. */
export function LogoMark({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <svg className={cx('pl-logo__mark', className)} width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
      <rect width="40" height="40" rx="13" fill="var(--pl-coral)" />
      <path d="M14 29V11h7a6 6 0 0 1 0 12h-7" fill="none" stroke="var(--pl-plum)" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Product line shown as a small tag after the wordmark. Planella is the master brand; "beauty" is this product. */
export const PRODUCT_LINE = 'beauty';

export function Wordmark({ size = 26, tone = 'light', className, line = PRODUCT_LINE }: { size?: number; tone?: 'light' | 'dark'; className?: string; line?: string | null }) {
  return (
    <span className={cx('pl-wordmark', tone === 'dark' && 'pl-wordmark--dark', className)} style={{ fontSize: size }} dir="ltr">
      Planella
      {line ? <span className="pl-wordmark__line">{line}</span> : null}
    </span>
  );
}

export function Logo({ size = 40, tone = 'light', markOnly, className, ...rest }: LogoProps) {
  if (markOnly) return <LogoMark size={size} className={className} />;
  return (
    <span className={cx('pl-logo', className)} role="img" aria-label={`Planella ${PRODUCT_LINE}`} {...rest}>
      <LogoMark size={size} />
      <Wordmark size={Math.round(size * 0.65)} tone={tone} />
    </span>
  );
}
